import { Inject, Injectable } from '@angular/core';
import { IUnitOfWorkFactory } from 'src/app/common/contracts/unit-of-work/unit-of-work-factory';
import { RightsetDB } from 'src/app/common/repository/databases';
import { UnitOfWorkFactory } from 'src/app/common/unit-of-work/unit-of-work-factory';
import { RightsetDto } from 'src/app/shared/models/user-management/rightset-dto.model';

import { WorkItem } from '../work-item';

@Injectable({ providedIn: 'root' })
export class RightsetWorkItem extends WorkItem<RightsetDto> {
  constructor(@Inject(UnitOfWorkFactory) unitOfWorkFactory: IUnitOfWorkFactory) {
    super(unitOfWorkFactory);
  }
  get name(): string {
    return 'RightsetWorkItem';
  }
  get database(): string {
    return RightsetDB;
  }
}
